// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05e7936d","455":"f093124c","977":"5500164d"}[chunkId] + ".chunk.js";
};